var _linearGradient, _path, _circle, _circle2, _path2, _path3, _path4, _path5, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcons81 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "500px",
    height: "500px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 39.004,
    x2: 9.35,
    y1: 11.109,
    y2: 40.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#fee66a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#feed97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#fff4bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#fff9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#fffcee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#fffefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M39.87,30.622l2.953-8.213L37.5,20.5l1.065-9.83l-6.608,0.915L24,4.868l-7.831,6.53l-5.931-0.645l0.832,9.873 l-5.915,2.636L7.5,28.5l-1.413,9l9.233-0.419l0.012,0C16.109,41.549,20.695,43.5,24,43.5c3.342,0,7.995-1.992,8.694-6.565 l8.851,0.756L39.87,30.622z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 28.5,
    r: 2.5,
    fill: "#fac400"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 28.5,
    r: 2.5,
    fill: "#fac400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fac400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M15.5,28.684c-0.314-0.112-0.647-0.184-1-0.184c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3 c0.353,0,0.686-0.072,1-0.184V36c0,5.247,5,7.5,8.5,7.5c0.091,0,0.183-0.002,0.276-0.005"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fac400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.262,41.15C31.584,39.943,32.5,38.246,32.5,36v-1.684c0.314,0.112,0.647,0.184,1,0.184c1.657,0,3-1.343,3-3 s-1.343-3-3-3c-0.353,0-0.686,0.072-1,0.184V24c0-5.247-3.253-9.5-8.5-9.5c-4.786,0-7.913,3.539-8.426,8.143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fac400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M16.5,11.5l-5.737-0.82c-0.643-0.092-1.201,0.444-1.136,1.089L10.5,20.5l-5.034,2.517 c-0.521,0.261-0.71,0.909-0.41,1.409L7.5,28.5l-0.869,7.822c-0.068,0.616,0.434,1.145,1.052,1.109l1.702-0.099"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fac400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M39.174,37.364L41.5,37.5l-1-9l2.484-4.969c0.272-0.544-0.001-1.203-0.578-1.396L37.5,20.5l0.873-8.73 c0.065-0.646-0.494-1.181-1.136-1.089L31.5,11.5l-6.818-6.363c-0.384-0.359-0.98-0.359-1.365,0l-2.494,2.328"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#fac400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "20.66,23.596 24.002,24.191 27.128,23.596"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.043,
    x2: 25.957,
    y1: 36.872,
    y2: 36.872,
    fill: "none",
    stroke: "#fac400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcons81);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons8-рик-санчес (1).b5c7343da154b51ab4ee4e1232c2568e.svg";